<script setup lang="ts">
  import type { IGlobalAlert } from '@/components/main-header/types'
  import { cva } from 'class-variance-authority'

  const props = withDefaults(defineProps<IGlobalAlert>(), {
    type: 'info',
    closable: false
  })

  const base = computed(() =>
    cva('py-4 text-bt-blue-dark md:items-center', {
      variants: {
        variant: {
          danger: 'bg-light-error',
          warning: 'bg-light-warning',
          info: 'bg-light-info'
        }
      }
    })({
      variant: props?.type as 'info' | 'danger' | 'warning'
    })
  )

  const text = computed(() => renderRichText(props.content))

  const isVisible = defineModel<boolean>({ default: true })
  const onClose = () => {
    if (!props.closable) {
      return
    }

    isVisible.value = false
  }
</script>

<template>
  <div
    v-if="isVisible"
    :class="base"
  >
    <div class="container flex w-full justify-between">
      <div class="flex gap-4">
        <Icon
          v-if="showDefaultIcon"
          name="common/outline-info"
          class="text-bt-red-dark"
        />
        <NuxtImg
          v-else
          width="24"
          height="24"
          :alt="icon?.alt"
          :src="icon?.source"
          provider="storyblok"
        />
        <div class="flex gap-4 text-body-2 [&_a]:text-inherit">
          <span
            class="text-bt-blue-dark"
            v-html="text"
          />
        </div>
      </div>
      <button
        v-if="closable"
        :aria-label="$t('aria.label.close')"
        class="self-start text-bt-blue-dark/30"
        @click="onClose"
      >
        <Icon name="common/close" />
      </button>
    </div>
  </div>
</template>
